import { createAsyncThunk } from '@reduxjs/toolkit';

import { getAuthenticatedToken } from '../../../services/authToken';
import { upsertRoadmapAiResponses } from '../../../services/database/ai-roadmap';
import logger from '../../../services/logger';
import { EnvironmentVariable } from '../../../utils/constants';

import { UserCareerRoadmap, UserData } from './roadmap-ai.type';

// Change return type to UserData (since we want the saved version)
export const fetchLatestRoadmapFromAPI = createAsyncThunk<UserData | null, string>(
  'roadmapAi/fetchFromAPI',
  async (userId: string) => {
    try {
      const token = await getAuthenticatedToken();

      const careerRoadmapUrl =
        process.env[EnvironmentVariable.REACT_APP_GET_ROADMAP_AI_RESPONSES_URL];
      if (!careerRoadmapUrl) {
        throw Error('URL missing');
      }
      const response = await fetch(careerRoadmapUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ userId }),
      });

      if (!response.ok) throw new Error(`Failed to fetch roadmap: ${response.statusText}`);

      const result: UserCareerRoadmap = await response.json();
      if (!result) throw Error('Roadmap Not Generated');

      const userData = await upsertRoadmapAiResponses({ ...result });

      if (userData.roadMap.length) {
        return userData;
      } else {
        throw Error('Something went wrong!');
      }
    } catch (error) {
      logger.error('Error fetching career roadmap from API:', error);
      throw Error('Somenthing went wrong');
    }
  },
);
